import { render, staticRenderFns } from "./ModalCredit.vue?vue&type=template&id=1c985cf8&scoped=true"
import script from "./ModalCredit.vue?vue&type=script&lang=js"
export * from "./ModalCredit.vue?vue&type=script&lang=js"
import style0 from "./ModalCredit.vue?vue&type=style&index=0&id=1c985cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c985cf8",
  null
  
)

export default component.exports